import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import PanelSearchCnpj from '../search/PanelSearchCnpj'
import TableBlock from './TableBlock'

function PanelBlockCnpj({
  classes,
  cnpj,
}) {
  return (
    <PanelSearchCnpj 
      cnpj={cnpj}
      TableComponent={TableBlock} />
  )
}

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1
  }
})

export default withStyles(styles)(PanelBlockCnpj)